const MONTH_FORMATTER = new Intl.DateTimeFormat("en-US", { month: "long" });

/**
 * The "Spread your Sparks" card's own caption (923-core-context context/engineering/spark-rewards/phase-52-spread-your-sparks.md §3): the VIEWER's own
 * most recent approved recognition of this teammate, always from an earlier quarter -- `null` means
 * the viewer has never recognised them. No existing date helper in `shared/utils/function.tsx`'s own
 * date-format family (`getGbFormattedDate` et al.) produces a bare month name, so this is a new, narrow
 * formatter rather than a fourth argument bolted onto one of those.
 *
 * Co-located with its own unit test rather than folded into `leaderboardEmptyCopy.ts` -- a caption
 * builder for a DIFFERENT card, sharing no vocabulary with that module's board/period copy.
 *
 * @param lastRecognisedAt - the ISO timestamp of the viewer's last approved recognition of this person,
 *   or `null` if they have never recognised them (`SuggestedCollaborator.last_recognised_at`).
 * @returns `"never recognised by you"` for `null`, or `"last recognised in <Month>"` otherwise.
 */
export const lastRecognisedCaption = (lastRecognisedAt: string | null): string => {
  if (lastRecognisedAt === null) {
    return "never recognised by you";
  }
  return `last recognised in ${MONTH_FORMATTER.format(new Date(lastRecognisedAt))}`;
};
